import { useEffect } from "react";
import PlanManagement from "../../../../components/usage/management";

import { Settings, User } from "../../../../interfaces";
import { FormattedMessage } from "react-intl";

const Billing: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  useEffect(() => {
    props.onRequestSettings();
  }, []);

  return (
    <div className={`settings-presentation`}>
      <h4>
        <FormattedMessage id="payment.title" />
      </h4>
      <p className="color-step-700 fs-3">
        <FormattedMessage id="payment.subTitle" />
      </p>
      <hr />
      <PlanManagement settings={props.settings} />
    </div>
  );
};

interface ILayoutProps {
  settings: Settings;
  user: User;
  onRequestSettings: Function;
}

export default Billing;
